import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import NotFound from "pages/NotFound";
import UserLogin from './pages/user-login';
import ProjectManagement from './pages/project-management';
import AdminDashboard from './pages/admin-dashboard';
import AccountSettings from './pages/account-settings';
import CreditCreation from './pages/credit-creation';
import UserManagement from './pages/user-management';
import UserDashboard from './pages/user-dashboard';
import UserRegistration from './pages/user-registration';
import VideoRenderingPage from './pages/video-rendering';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<ProjectManagement />} />
          <Route path="/user-login" element={<UserLogin />} />
          <Route path="/project-management" element={<ProjectManagement />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/account-settings" element={<AccountSettings />} />
          <Route path="/credit-creation" element={<CreditCreation />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/user-dashboard" element={<UserDashboard />} />
          <Route path="/user-registration" element={<UserRegistration />} />
          <Route path="/video-rendering" element={<VideoRenderingPage />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;